import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
// import {IPayPalConfig, PayPalScriptService, NgxPaypalComponent} from 'ngx-paypal';
import {CheckoutService} from '../checkout.service';
import {tap} from 'rxjs/operators';
import {WalletService} from '../../wallet/wallet.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CartService} from '../../cart/cart.service';

@Component({
  selector: 'app-paypal',
  templateUrl: './paypal.component.html',
  styleUrls: ['./paypal.component.scss']
})
export class PaypalComponent implements OnInit, AfterViewInit {
  // payPalConfig: IPayPalConfig;
  private showSuccess: boolean;
  private showError: boolean;
  private showCancel: boolean;

  // @ViewChild("paypal") paypalComponent?: NgxPaypalComponent;
  private currentOrderId: string;

  constructor(
    // private payPalScriptService: PayPalScriptService,
              private walletService: WalletService,
              private router: Router,
              private cartService: CartService,
              private route: ActivatedRoute,
              public checkoutService: CheckoutService) { }

  ngOnInit(): void {
    this.initConfig();
  }

  ngAfterViewInit() {
    // this.subscriptionPayPal();
  }

  private fetchId(data: string) {
    const startIndex = data.indexOf("\"id\":");
    const endIndex = data.indexOf(",", data.indexOf("\"id\":"));
    if (startIndex < 0 || endIndex < 0) { return null; }
    const id = data.substring(startIndex + 6, endIndex - 1);
    return id;
  }
  private initConfig(): void {

    const { request } = this.checkoutService.selectedPaymentRequest.value;
    request()
      .pipe(
        tap(() =>
          this.checkoutService.refreshCheckout({ paymentType: "CREDIT_CARD" })
        )).subscribe(response => {
      console.log(response);
      if (response.clientSecret) {
        console.log(response.clientSecret);
        this.router.navigate(["/DY1jFI765pz92Tr7OZphOvkDEldyygZO"], {
          queryParams: { id: this.fetchId(response.clientSecret) },
        });
      }
    });
    //   this.payPalConfig = {
    //     clientId: PAYPAL_CLIENT_ID,
    //     currency: 'EUR',
    //     // for creating orders (transactions) on server see
    //     // https://developer.paypal.com/docs/checkout/reference/server-integration/set-up-transaction/
    //     createOrderOnServer: (data) => this.checkoutService
    //       .getPayPalOrder({amount: Number.parseFloat(checkout.toFixed(2)), currency: 'EUR'})
    //       .then((res) => {
    //         this.currentOrderId = res.id;
    //         return res;
    //       })
    //       .then((order) => order.id),
    //     onApprove: (data, actions) => {
    //       actions.order.get().then(details => {
    //       });
    //
    //     },
    //     onClientAuthorization: (data) => {
    //       if (data.status == 'COMPLETED') {
    //         this.checkoutService.sendPaypalApproved(this.currentOrderId).subscribe(res => {
    //           this.cartService.removeAllProductFromCart()
    //           this.walletService.syncWalletBalance();
    //           afterCloseDialog();
    //           afterSuccess();
    //           this.router.navigate([routerLink], {
    //             relativeTo: this.route,
    //             queryParams,
    //           });
    //         });
    //       }
    //
    //       this.showSuccess = true;
    //     },
    //     onCancel: (data, actions) => {
    //       this.showCancel = true;
    //
    //     },
    //     onError: err => {
    //       this.showError = true;
    //     },
    //     onClick: (data, actions) => {
    //       this.resetStatus();
    //     },
    //   };
    //
    // });
  }

  // subscriptionPayPal() {
  //   this.payPalConfig = this.getConfig("P-1DJ34241PL864415FMXK37OYnpm i @paypal/paypal-js");
  //   // this.payPalScriptService.registerPayPalScript({
  //   //   clientId: PAYPAL_CLIENT_ID,
  //   //   currency: 'EUR',
  //   //   vault: "true",
  //   //   extraParams: [{name: "enable-funding", value: "applepay"},{name: "disable-funding", value: "card"}]
  //   // },
  //   //   (paypalApi) => {
  //   //   this.paypalComponent.customInit(paypalApi);
  //   // });
  // }

  private resetStatus() {}

  // getConfig(planId: string): IPayPalConfig {
  //   // const { routerLink, queryParams, request, afterSuccess, afterCloseDialog } =
  //   //   this.checkoutService.selectedPaymentRequest.value;
  //   // return {
  //   //   clientId: PAYPAL_CLIENT_ID,
  //   //   currency: "EUR",
  //   //   vault: "true",
  //   //   // style: {
  //   //   //   label: "paypal",
  //   //   //   layout: "vertical",
  //   //   //   size: "small",
  //   //   //   shape: "pill",
  //   //   //   color: "silver",
  //   //   //   tagline: false,
  //   //   // },
  //   //   advanced: {
  //   //     extraQueryParams: [{name: "enable-funding", value: "card"}]
  //   //   },
  //   //   createSubscription: (data, actions) => {
  //   //     return actions.subscription.create({
  //   //       plan_id: planId,
  //   //     });
  //   //   },
  //   //   onApprove: (data, actions) => {
  //   //     actions.subscription.get().then(details => {
  //   //       afterSuccess();
  //   //     });
  //   //
  //   //   },
  //   //   onCancel: (data, actions) => {
  //   //     this.showCancel = true;
  //   //
  //   //   },
  //   //   onError: err => {
  //   //     this.showError = true;
  //   //   },
  //   //   onClick: (data, actions) => {
  //   //     this.resetStatus();
  //   //   },
  //   // };
  // }

}
